.center {
    flex: 1;

    display: grid;
    place-content: center;
    place-items: center;

    height: 100%;
}
